import { cn } from '@/lib/utils.ts'

export function ActionSectionHeader({
  children,
  className = '',
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        'flex items-center gap-2 font-dm-mono text-xs font-medium uppercase text-base-foreground',
        className
      )}
    >
      {children}
      <hr className="grow" />
    </div>
  )
}
